import { getApplicationSettings } from "owa-application-settings";

export function isEmailTypesEnabled(): boolean {
    return getApplicationSettings("Jana").enableEmailTypes;
}
